const prvaDiagnozaPremija = {
    placiloPrvePremija: {
        name: 'placiloPrvePremija',
        type: 'tns:PrvaPremijaVnaprej',
        formType: 'radio-multiple',
        value: undefined,
        required: true,
        error: null,
        text: {
            sl: 'Način plačila prve premije',
        },
        options: [
            { 
                name: 'sepa',
                value: 'SEPA',
                text: {
                    sl: 'SEPA',
                },
            },
            { 
                name: 'upn',
                value: 'UPN',
                text: {
                    sl: 'UPN',
                },
            },
        ],
    },
}

module.exports = { prvaDiagnozaPremija };